
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface TileProps {
  title: string;
  description: string;
  onClick?: () => void;
  actionLabel?: string;
  onActionClick?: () => void;
  className?: string;
  children?: React.ReactNode;
  isClickable?: boolean;
}

export const Tile = ({
  title,
  description,
  onClick,
  actionLabel,
  onActionClick,
  className,
  children,
  isClickable = true,
}: TileProps) => {
  return (
    <div
      onClick={isClickable ? onClick : undefined}
      className={cn(
        "rounded-2xl overflow-hidden bg-gradient-to-b from-[#fdfcfb] to-[#e2d1c3] transition-colors aspect-square flex flex-col p-6",
        isClickable && "cursor-pointer hover:from-[#e2d1c3] hover:to-[#fdfcfb]",
        className
      )}
    >
      <div className="flex-1">
        <h3 className="text-xl font-medium text-[#221F26] mb-4">{title}</h3>
        <p className="text-[#221F26]/90 text-sm mb-6">{description}</p>
        {children}
      </div>
      {actionLabel && (
        <Button
          variant="ghost"
          onClick={(e) => {
            e.stopPropagation();
            onActionClick?.();
          }}
          className="text-[#221F26] bg-[#221F26]/10 px-3 py-1.5 rounded-full text-sm w-fit mt-4 hover:bg-[#221F26]/20 transition-colors"
        >
          {actionLabel}
        </Button>
      )}
    </div>
  );
};
